<template>
  <div id="notification-drawer-btn"
       class="position-relative btn shadow-sm btn-icon btn-icon-muted btn-active-light btn-active-color-primary text-primary w-30px w-md-40px fs-4"
       data-kt-menu-trigger="hover" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end"
       :style="{'border': '1px solid '+ $getCssVariable('--bs-primary') }"
  >
    <i class="bi bi-bell-fill text-primary fs-2"></i>
    <span class="position-absolute top-0 start-100 translate-middle badge badge-warning"
          :class="[
              { 'badge-circle': count <= 99 },
              { 'badge-square': count > 99 },
          ]">
      {{ count }}
    </span>
  </div>
</template>

<script setup>


defineProps({
  count: Number,
})


</script>

<style scoped>
</style>
